export const comments_5480352 = {"data":{"data":[],"links":{}}}